import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = { class: "ValidationMessage" }
const _hoisted_3 = {
  key: 1,
  class: "CampaignEditorText CampaignEditorReadOnlyInputBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldClashingWithCampaignLiftExcluded }
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel CampaignSettingsInputRequired" }, " Partnership type ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isCampaignCreation)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_MultiSelect, {
                ref: "partnershipTypeDropdown",
                label: "Partnership Type",
                placeholder: " ",
                class: "CampaignEditorDropdown",
                options: _ctx.options,
                onUpdated: _ctx.setPartnershipType
              }, null, 8 /* PROPS */, ["options", "onUpdated"]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.validationMessage), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.nameOfSelectedPartnershipType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.nameOfSelectedPartnershipType), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}